









import { ColorsList } from '../../core/utils/type-colors';
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import AlertBox from '../../core/components/AlertBox.vue';
@Component({
    components: {
        AlertBox
    }
})
export default class VariableGroupAlert extends Vue {
    skyColor: string = ColorsList.skyblue;
    msgInfo: string = 'Los dispositivos G28, Sinotrack y Quecklink no van a ser afectados por grupos de variables';

    mounted() {}
}
